export default __webpack_public_path__ + "static/media/rent_icon.5a6c8303.png";